import { AbstractCustomTableToolsPanel } from "./AbstractCustomTableToolsPanel";

export class CustomRightTableToolsPanel extends AbstractCustomTableToolsPanel {
    override getPopulatedPaddingLeft(): number {
        return 4;
    }

    override getPopulatedPaddingRight(): number {
        return 0;
    }
}
